import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'

/**
 * SAFICドメインか判定する
 * @returns SAFICドメインならtrue, それ以外ならfalseを返却する
 */
export const isSaficDomain = (): boolean => {
  return CLIENT_SETTINGS.targetDomain === DOMAIN.SAFIC
}

/**
 * SJドメインか判定する
 * @returns SJドメインならtrue, それ以外ならfalseを返却する
 */
export const isSjDomain = (): boolean => {
  return CLIENT_SETTINGS.targetDomain === DOMAIN.SJ
}

/**
 * 現在のクライアント設定のドメインを取得する
 * @returns クライアント設定のドメイン
 */
export const getDomain = (): string => {
  return CLIENT_SETTINGS.targetDomain
}
